<template>
    <app-layout>
        <template #header>
            <div class="md:grid md:grid-cols-3 md:gap-6">
              <h2 class="md:col-span-2 font-semibold text-xl text-gray-800 leading-tight">
                    New User
                </h2>   
            </div>
        </template>
        
        <div class="mx-4 sm:mx-8 px-4 sm:px-8 py-4">
            <div class="md:grid md:grid-cols-4 md:gap-6">
        
                   <div class="md:col-span-3">
                        <div class="bg-white rounded shadow overflow-hidden max-w-3xl">

                            <form @submit.prevent="handleSubmit">  
                                <div class="p-8 -mr-6 -mb-8 flex flex-wrap">

                                 <div class="pr-6 pb-8 w-full lg:w-1/2">
                                    <label class="text-gray-700 capitalize" for="name">Name</label>
                                    <input class="form-input w-full mt-2 rounded-md focus:border-indigo-600" type="text" v-model="user.name" :error="errors.name">
                                     <span v-if="errors.name" class="error"><p style="color:red;">{{ errors.name }}</p></span>
                                </div>
                                    <div class="pr-6 pb-8 w-full lg:w-1/2">
                                      <label class="text-gray-700 capitalize" for="alias">E-mail</label>
                                      <input class="form-input w-full mt-2 rounded-md focus:border-indigo-600" type="text" v-model="user.email" :error="errors.email">
                                      <span v-if="errors.email" class="error"><p style="color:red;">{{ errors.email }}</p></span>
                                </div>
                                <!-- <div class="pr-6 pb-8 w-full lg:w-1/2">
                                      <label class="text-gray-700 capitalize" for="password">Password</label>
                                      <input class="form-input w-full mt-2 rounded-md focus:border-indigo-600" type="text" v-model="user.password" :error="errors.password">
                                      <span v-if="errors.password" class="error"><p style="color:red;">{{ errors.password }}</p></span>
                                </div> -->
                                <div class="pr-6 pb-8 w-full lg:w-1/2">
                                      <label class="text-gray-700 capitalize" for="">Select Role</label>
                                     <select class="form-input w-full mt-2 rounded-md focus:border-indigo-600" v-model="user.role_id">
                                     <!-- <option value="1">Super Admin</option> -->
                                     <option value="2">Organization Admin</option>
                                     <option value="3">Trainer</option>
                                     <option value="4">Client</option>
                                </select>
                                </div>

                              
                               

                                </div>
                                 
                                  <div class="px-8 py-4 bg-gray-100 border-t border-gray-200 flex text-right">
                                <button class="px-5 py-2 bg-gray-800 text-gray-200 rounded-md hover:bg-gray-700 focus:outline-none focus:bg-gray-700"> Save </button>
                                </div>


                         </form>   
                    </div>                               
                </div> 
              </div>
          </div>
      
       </app-layout>
</template>
<script>
import AppLayout from '@/js/Layouts/AppLayout'
import ManagerLayout from './../../../Layouts/ManagerLayout'

export default {
     components: {
        AppLayout
    },
    metaInfo() {
        return {
            title: 'Novi Korisnik' 
        }
    },
    data(){
        return{
            user: {
                name: '',
                email: '',
                // password:'',
                role_id:''
            }
        }
    },
    props:{
        errors: Object
    },

    methods:{

        async handleSubmit(){

        this.sending = true;

        let response = await this.$inertia.post('/backoffice/users/store', this.user)
                    // .then(() => this.sending = false)
                    .then(function(response){
                            this.user = response.data;
            
                    })
                    
              },       
        }   

}
</script>